import React, { createContext, useState, useEffect, ReactNode } from 'react';
import WaitingMessage from '../components/WaitingMessage';
import { getAllFeatureFlags } from '../services/feature-flags.service';

interface FeatureFlags {
	[key: string]: boolean;
}

interface FeatureFlagContextType {
	featureFlags: FeatureFlags;
	isLoading: boolean;
}

export const FeatureFlagContext = createContext<FeatureFlagContextType>({
	featureFlags: {},
	isLoading: true,
});

interface FeatureFlagProviderProps {
	children: ReactNode;
}

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({ children }) => {
	const [featureFlags, setFeatureFlags] = useState<FeatureFlags>({});
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getAllFeatureFlags()
			.then((res) => {
				setFeatureFlags(res.featureFlags);
			})
			.catch((err) => {
				console.error('Error fetching feature flags:', err);
				setFeatureFlags({});
			})
			.finally(() => setIsLoading(false));
	}, []);

	if (isLoading) {
		return <WaitingMessage />;
	}

	return <FeatureFlagContext.Provider value={{ featureFlags, isLoading }}>{children}</FeatureFlagContext.Provider>;
};
